import { Component } from '@angular/core';

@Component({
  selector: 'bnpp-indx-termofuse',
  imports: [],
  templateUrl: './termofuse.component.html',
  styleUrl: './termofuse.component.scss',
  standalone:true
})
export class TermofuseComponent {

}
